import companiesListComponent from './companies-list.component';

const companiesListModule = angular
  .module('companiesList', [])
  .component('companiesList', companiesListComponent);

export default companiesListModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-list/companies-list.js
 **/